import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { computed, type MaybeRefOrGetter, unref } from 'vue';
import { useLoaderStore } from '@/shared/store/useLoaderStore';

export const useCitySeoInfo = (
  citySlug: MaybeRefOrGetter<string>,
  currentTag: MaybeRefOrGetter<string>,
  page: MaybeRefOrGetter<number>,
  enabled: MaybeRefOrGetter<boolean>,
) => {
  const loaderStore = useLoaderStore();

  const { getSeoByCitySlug, getSeoByCityTag } = useExperienceApi();
  const hasTagInUrl = computed(() => {
    const tag = unref(currentTag);

    return Boolean(tag && tag !== 'all');
  });
  const cityTagCompositeId = computed(() => `${unref(citySlug)}__${unref(currentTag)}`);

  const {
    data: citySeoData,
    isSuccess,
    isFetching,
    isFetched,
  } = useQuery({
    queryKey: ['citySeoInfo', citySlug, currentTag, page],
    queryFn: async () => {
      const response = hasTagInUrl.value
        ? await getSeoByCityTag({
            query: { ids: cityTagCompositeId.value },
          })
        : await getSeoByCitySlug({
            query: { ids: unref(citySlug) as string },
          });

      loaderStore.check404(response);

      return response;
    },
    enabled: computed(() => Boolean(unref(enabled))),
    placeholderData: (prev) => prev,
    select: (response) => response.data,
  });

  return {
    isFetched,
    isSuccess,
    isFetching,
    citySeoData,
  };
};
